import Config from 'common-src/config';

export const AthenaDepartment = {
  NeurologyDanvers: {
    id: 1,
    value: 'Neurology Danvers',
    label: 'Danvers',
  },
  GUIDE: {
    id: 2,
    value: 'GUIDE',
    label: 'GUIDE',
  },
  NeurologyOrangeCounty: {
    id: 4,
    value: 'Neurology Orange County',
    label: 'Downey',
  },
  NeurologyBayArea: {
    id: 5,
    value: 'Neurology Bay Area',
    label: 'San Jose',
  },
  NeurologyLongBeach: {
    id: 6,
    value: 'Neurology Long Beach',
    label: 'Long Beach',
  },
  TestDepartment: {
    id: 3,
    value: 'Test Department',
    label: 'Test Department',
  },
};

export const AthenaDepartmentsOptions = Object.values(AthenaDepartment).map((department) => ({
  label: department.label,
  value: department.value,
}));

export const AthenaPracticeOptions = [JSON.parse(Config.ATHENA_MINDSPAN_GROUP_PRACTICE)];

export const AthenaCustomFieldIds = {
  member_id: '32',
  pcp_first_name: '25',
  pcp_last_name: '26',
  pcp_phone_number: '27',
  legacy_patient_id: '1',
};
